/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AccountLookupRequestType {
    None = 0,
    Barcode = 1,
    AccountNumber = 2,
    AccountNumberAndLastName = 4,
    Phone = 8,
    PhoneAndLastName = 16,
    StreetNumber = 32,
    StreetNumberAndLastName = 64,
}
